import { apiService } from './api'
import { Test, TestResult, TestSubmission, TestGenerationRequest } from '../types/test'

export class TestService {
  // テスト一覧取得
  static async getTests(params?: {
    page?: number
    limit?: number
    search?: string
    category?: string
    complianceRuleId?: string
    isActive?: boolean
  }): Promise<{
    tests: any[]
    pagination: {
      page: number
      limit: number
      total: number
      pages: number
    }
  }> {
    return await apiService.get<{
      tests: any[]
      pagination: {
        page: number
        limit: number
        total: number
        pages: number
      }
    }>('/tests', params)
  }

  // テスト取得
  static async getTest(id: string): Promise<Test> {
    return await apiService.get<Test>(`/tests/${id}`)
  }

  // テスト生成（非同期 - 即座にレスポンスが返る）
  static async generateTest(
    data: TestGenerationRequest
  ): Promise<{ message: string; generating: boolean }> {
    const response = await apiService.post<{ message: string; generating: boolean }>(
      '/tests/generate',
      data
    )

    return response
  }

  // テスト提出
  static async submitTest(
    submission: TestSubmission
  ): Promise<{ message: string; result: TestResult }> {
    return await apiService.post<{ message: string; result: TestResult }>(
      '/tests/submit',
      submission
    )
  }

  // テスト再生成
  static async regenerateTest(testId: string, feedback?: string): Promise<{ message: string }> {
    return await apiService.post<{ message: string }>(`/tests/${testId}/regenerate`, { feedback })
  }

  // 規範IDでテスト一覧取得
  static async getTestsByComplianceRuleId(
    complianceRuleId: string,
    params?: {
      page?: number
      limit?: number
      search?: string
    }
  ): Promise<{
    tests: any[]
    pagination: {
      page: number
      limit: number
      total: number
      pages: number
    }
  }> {
    return await this.getTests({
      ...params,
      complianceRuleId,
    })
  }

  // テスト更新
  static async updateTest(
    id: string,
    data: {
      title?: string
      description?: string
      passingScore?: number
      timeLimit?: number
      isActive?: boolean
    }
  ): Promise<{ message: string; test: Test }> {
    return await apiService.put<{ message: string; test: Test }>(`/tests/${id}`, data)
  }

  // テスト削除
  static async deleteTest(
    id: string
  ): Promise<{ message: string; deleted: boolean; deactivated?: boolean }> {
    return await apiService.delete<{ message: string; deleted: boolean; deactivated?: boolean }>(
      `/tests/${id}`
    )
  }

  // テスト手動作成（AI生成なし）
  static async createTest(data: {
    complianceRuleId: string
    title: string
    description?: string
    passingScore?: number
    timeLimit?: number
  }): Promise<{ message: string; test: Test }> {
    return await apiService.post<{ message: string; test: Test }>('/tests', data)
  }
}
